import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { IconVaccineOff } from "@tabler/icons-react";
import { getMemberInfo } from "@/hooks/useMembers";
import { appendToPath } from "@/utils/nav-utils";
import MEmptyCard from "@/components/ui/organisms/MEmptyCard";
import MSpacer from "@/components/ui/atoms/MSpacer";
import MSelectCard from "@/components/ui/atoms/MSelectCard";

/**
 * Splash screen component displayed when a user has no vaccinations
 * Shows FormHeader with title and description, and two CTA buttons
 */
const AddVaccinePage: React.FC<{ doVaccinesExist?: boolean }> = ({
  doVaccinesExist = false,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const memberInfo = getMemberInfo();
  const { derivedMemberType } = memberInfo;
  const isChild = derivedMemberType === "C";

  return (
    <>
      <MSpacer />
      {/* CTA Buttons */}
      <div className="w-full">
        {doVaccinesExist ? (
          <div className="flex flex-col gap-6">
            <MSelectCard
              text={t("vaccinations.add")}
              onClick={() =>
                navigate(appendToPath(location.pathname, "add-vaccine"))
              }
              className="w-full"
              selected={true}
              centerAlign
            />
            <MSelectCard
              text={t("vaccinations.per-age")}
              onClick={() =>
                navigate(appendToPath(location.pathname, "suggested-vaccines"))
              }
              className="w-full"
              centerAlign
            />
          </div>
        ) : (
          <MEmptyCard
            icon={<IconVaccineOff />}
            primaryTitle={t("vaccinations.no-vaccines")}
            primaryCTA={{
              text: t("vaccinations.add"),
              onClick: () =>
                navigate(appendToPath(location.pathname, "add-vaccine")),
            }}
            secondaryCTA={
              isChild
                ? {
                    text: t("vaccinations.per-age"),
                    onClick: () =>
                      navigate(
                        appendToPath(location.pathname, "suggested-vaccines")
                      ),
                  }
                : undefined
            }
          />
        )}
      </div>
    </>
  );
};

export default AddVaccinePage;
